import React, {Component} from "react";
import { EditorState, convertToRaw  } from 'draft-js';
import { Editor} from "react-draft-wysiwyg";
import draftToHtml from 'draftjs-to-html';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {stateFromHTML} from "draft-js-import-html";

class Newsform extends Component{
    constructor(props) {
        super(props);
        const contentBlocks = stateFromHTML(this.props.data.content);
        this.state = {
            editorState: EditorState.createWithContent(contentBlocks  !=="" ?  contentBlocks : ''),
        };
    }

    onEditorStateChange  = editorState => {
        this.setState({
            editorState,
        });
        this.props.data.content = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    };
    render() {
        const { editorState } = this.state;
        return (
            <form onSubmit={this.props.handleSubmit}>
            <div className="card-body"  style={{textAlign: 'left'}}>
                <div className="scroll-y me-n7 pe-7" id="kt_modal_new_address_scroll text-left" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_new_address_header" data-kt-scroll-wrappers="#kt_modal_new_address_scroll" data-kt-scroll-offset="300px">
                    <div className="row mb-5">
                        <div className="col-md-12 fv-row">
                            <label className="required fs-5 fw-bold mb-2">News Title</label>
                            <input
                                type="text"
                                className="form-control form-control-solid  mb-5"
                                name="title"
                                id="title"
                                onChange={this.props.onEdit}
                                value={this.props.data.title}
                                placeholder="News Title"

                            />
                        </div>

                        </div>
                        <div className="row mb-5">
                            <div className="col-md-6 fv-row">
                                <label className="required fs-5 fw-bold mb-2">Image</label>
                                <input
                                    type="file"
                                    className="form-control form-control-solid  mb-5"
                                    name="photo"
                                    id="photo"
                                    onChange={this.props.onImageChange}
                                    accept="image/*"
                                />
                            </div>
                            <div className="col-md-6 fv-row">
                                <label className="required fs-5 fw-bold mb-2">Status</label>
                                <select
                                    className="form-control form-control-solid"
                                    name="status"
                                    id="status"
                                    onChange={this.props.onEdit}
                                    value={this.props.data.status}
                                >
                                    <option value="">Select Status</option>
                                    <option value="1">Publish</option>
                                    <option value="0">Draft</option>
                                </select>
                            </div>
                        </div>

                    <div className="d-flex flex-column mb-9 fv-row">
                        <label className="required fs-5 fw-bold mb-2">News Content</label>
                        <Editor
                            className="form-control form-control-solid"
                            rows={4}
                            name="content"
                            id="content"
                            onEditorStateChange={this.onEditorStateChange}
                            wrapperClassName="form-control form-control-solid"
                            editorClassName="form-control form-control-solid"
                            editorState={editorState}
                        />

                    </div>




                        <button type="submit" id="kt_modal_new_address_submit" data-kt-indicator={this.props.isLoading} className="btn btn-primary w-25 offset-sm-4 mb-9 mt-9">
                            <span className="indicator-label">Submit</span>
                            <span className="indicator-progress">Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"/>
                        </span>
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

export default Newsform;